export const CDN_BUILD_URL_ENV_VAR = "NEXT_PUBLIC_CDN_BUILD_URL";
export const CDN_BUILD_CONTAINER_NAME_ENV_VAR = "NEXT_PUBLIC_CDN_BUILD_CONTAINER_NAME";
export const CDN_MEDIA_URL_ENV_VAR = "NEXT_PUBLIC_CDN_MEDIA_URL";
